import {getLang} from "./helpers";

require('intersection-observer');

import * as tts from './tts';

import {Router} from '../common/router';
const lang = getLang();
const mainCtn = document.querySelector('main');
const mainQuery = mainCtn.dataset.query ? JSON.parse(mainCtn.dataset.query) : {};

let query = {},
    btn;

export const initSeeMore = (resultsCtn, ttsEnabled = true) => {

    if (!resultsCtn) {
        return;
    }

    const fetchPath = resultsCtn.dataset.path;

    if (!fetchPath || !resultsCtn.dataset.size || !resultsCtn.dataset.total) {
        console.error('Missing one of the following data attribute on the results container to init the see more component: path, size, total.');

        return;
    }

    initQuery(resultsCtn.dataset);

    if (query.from >= query.total) {
        return;
    }

    createBtn();
    resultsCtn.insertAdjacentElement('afterend', btn);

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                fetchNextResults(resultsCtn, fetchPath, ttsEnabled);
            }
        });
    });

    observer.observe(btn);
}

const initQuery = data => {
    const total = parseInt(data.total);
    const size = parseInt(data.size);
    const from = data.from ? parseInt(data.from) : size;
    const nextPageSize = Math.min(total - from, size);
    const additionalQuery = !!data.query ? JSON.parse(data.query) : {};

    query = {from, size, nextPageSize, total, ...additionalQuery};
}

const createBtn = () => {
    const p = document.createElement('p');
    p.innerHTML = Translator.trans('results.see_more', {'number': query.nextPageSize}, 'app');
    const icon = document.createElement('i');
    icon.classList.add('fal', 'fa-long-arrow-down', 'fa-2x');

    btn = document.createElement('div');
    btn.setAttribute('id', 'more-results');
    btn.insertAdjacentElement('beforeend', p);
    btn.insertAdjacentElement('beforeend', icon);
}

const fetchNextResults = (resultsCtn, path, ttsEnabled) => {
    if (btn.classList.contains('disabled')) {
        return;
    }

    const params = {
        ...mainQuery,
        from: query.from,
        size: query.nextPageSize,
        render: true,
    };

    if(!('from' in mainQuery && mainQuery.from)) {
        params.page = Math.ceil(query.from / query.size) + 1;
    }

    const url = Router.generate(
        `${path}.${lang}`,
        params
    );

    toggleBtn();

    fetch(url, {
        'headers': {
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(response => {
        if (response.ok) {
            response.text().then(html => {
                const detail = response.headers.get('detail')
                    ? JSON.parse(response.headers.get('detail'))
                    : {}
                ;
                resultsCtn.insertAdjacentHTML('beforeend', html);
                toggleBtn();
                updateQuery();
                updateAttributes();

                document.dispatchEvent(new CustomEvent('nextResultsFetched', {detail}));

                if (ttsEnabled) {
                    tts.page();
                }
            });
        } else {
            btnToError();
        }
    }).catch(error => {
        console.error(error);
        btnToError();
    });
}

const toggleBtn = () => {
    const p = btn.querySelector('p');
    const text = btn.classList.contains('disabled') ? 'results.see_more' : 'results.see_more_loading';
    p.innerHTML = Translator.trans(text, {'number': query.nextPageSize}, 'app');

    const icon = btn.querySelector('i');
    ['fa-spinner', 'fa-spin', 'fa-long-arrow-down'].map(cssClass => {
        icon.classList.toggle(cssClass);
    });

    btn.classList.toggle('disabled');
}

const btnToError = () => {
    const p = btn.querySelector('p');
    p.innerHTML = Translator.trans('results.see_more_error', {}, 'app');
    btn.querySelector('i').remove();
    btn.classList.toggle('disabled');
}

const updateQuery = () => {
    query.from += query.nextPageSize;

    if (query.from >= query.total) {
        btn.remove();

        return;
    }

    if (query.total - query.from < query.nextPageSize) {
        query.nextPageSize = query.total - query.from;
        btn.querySelector('.more-results-number').innerText = query.nextPageSize;
    }
}

const updateAttributes = () => {
    mainCtn.dataset.currentPage = query.from > 0 ? Math.round((query.from / query.size) + 1) : 1;
};
